// La tira "En cola": los mensajes que esperan a que el agente termine, arriba de la caja
// (ADR-2026-09-13-la-cola-de-mensajes-del-agente). Vivía adentro de `BarraEntradaChat`; salió acá
// para que la usen también las cajas de Crear y de Redes, que encolaban sin mostrar nada
// (ADR-2026-10-22-la-cola-se-ve-en-crear-y-redes). La caja se le monta encima (`-mb-5` + `pb-8`)
// para que la costura no se vea: va justo antes de la caja.
import { Clock, Paperclip, X } from 'lucide-react';
import type { MensajeEnCola } from '../colaDeMensajes';

export const TiraDeLaCola: React.FC<{
  cola: MensajeEnCola[];
  onQuitar: (indice: number) => void;
  /**
   * Una card propia, separada de la caja, en vez de la extensión que se le monta debajo. Para las
   * cajas que no son la del chat (Crear, Redes): su forma es otra y la costura no cerraba.
   */
  suelta?: boolean;
}> = ({ cola, onQuitar, suelta = false }) => {
  if (cola.length === 0) return null;
  return (
    <div
      className={`border-neutral-300 bg-[#F0F2F7] px-4 pt-3 animate-fade-in ${
        suelta ? 'mb-2 rounded-2xl border pb-3' : 'rounded-t-3xl border border-b-0 pb-8 -mb-5'
      }`}
    >
      <p className="mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-[rgb(var(--brand-black-rgb)_/_0.45)]">
        En cola
      </p>
      <ul className="flex flex-col gap-1">
        {cola.map((m, i) => {
          // Cuántas cosas van con ese mensaje: los chips más el lote, que es UN chip
          // pero muchas fotos (ADR-2026-09-13-la-cola-lleva-sus-adjuntos). Sin este
          // contador, la tira muestra sólo el texto y no hay forma de saber si los
          // adjuntos quedaron enganchados al mensaje o se perdieron.
          const cuantosAdjuntos = m.adjuntos.length + (m.loteFotos ? m.loteFotos.cantidad : 0);
          return (
          <li key={`${i}-${m.texto.slice(0, 24)}`} className="flex items-center gap-2 text-[13px] text-brand-black">
            <Clock className="h-3.5 w-3.5 shrink-0 text-[rgb(var(--brand-black-rgb)_/_0.4)]" aria-hidden="true" />
            <span className="min-w-0 flex-1 truncate">{m.texto}</span>
            {cuantosAdjuntos > 0 && (
              <span
                className="inline-flex shrink-0 items-center gap-1 rounded-full bg-[rgb(var(--brand-black-rgb)_/_0.06)] px-2 py-0.5 text-[11px] font-medium text-[rgb(var(--brand-black-rgb)_/_0.55)]"
                title={`${cuantosAdjuntos} adjunto${cuantosAdjuntos === 1 ? '' : 's'} en este mensaje`}
              >
                <Paperclip className="h-3 w-3" aria-hidden="true" />
                {cuantosAdjuntos}
              </span>
            )}
            <button
              type="button"
              onClick={() => onQuitar(i)}
              aria-label={`Sacar de la cola: ${m.texto.slice(0, 40)}`}
              className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[rgb(var(--brand-black-rgb)_/_0.45)] transition-colors hover:bg-[rgb(var(--brand-black-rgb)_/_0.06)] hover:text-brand-black"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </li>
          );
        })}
      </ul>
    </div>
  );
};
